<template>
  <div id="guia-impresso">
    <div>
      <div class="header">
        <h3 class="func-4-title-header">{{ funcionalidade.parametros.textos.tituloGuiaImpresso }}</h3>
      </div>
      <div class="py-4">
        <div v-if="guias && guias.length">
          {{ funcionalidade.parametros.textos.descricaoGuiaImpresso }}
        </div>
        <div v-else>
          <guiaImpressoEmpty/>
        </div>
      </div>
      <div v-if="guias && guias.length" id="list" class="space-y-2">
        <el-row class="table-header">
          <el-col :span="14">
            <span @click="sortGuiasBy('nome')">
              Nome do plano
              <i v-if="currentSort === 'nome'" :class="currentSortDir === 'asc' ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
            </span>
          </el-col>
          <el-col :span="5">
            <span @click="sortGuiasBy('data_publicado')">
              Atualização
              <i v-if="currentSort === 'data_publicado'" :class="currentSortDir === 'asc' ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
            </span>
          </el-col>
          <el-col :span="5">
          </el-col>
        </el-row>
        <template>
          <div v-for="guia in guias" :key="guia.id">
            <Func4GuiaImpressoItem :guia="guia" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Func4GuiaImpressoItem from '@/views/4/GuiaImpressoItem'
import GuiaImpressoEmpty from '@/views/4/GuiaImpressoEmpty'
import { mapActions, mapGetters, mapState } from 'vuex'
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'Func4GuiaImpresso',
  data () {
    return {
      guias: [],
      currentSort: 'nome',
      currentSortDir: 'asc'
    }
  },
  components: { Func4GuiaImpressoItem, GuiaImpressoEmpty },
  computed: {
    ...mapState('RedeCredenciada', [
      'apenasGuiaImpresso',
      'showGuiaImpresso'
    ]),
    ...mapGetters('SetupApp', ['aplicacao']),
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade', 'esquemaDeCor'])
  },
  methods: {
    ...mapActions('RedeCredenciada', ['setViewGuiaImpresso']),
    async buscaGuias () {
      const response = await this.apiFuncionalidade.guiaImpressoConfigurado({
        payload: { idOperadora: this.aplicacao.idOperadora },
        handlerErrorIgnore: [404],
        loading: true,
        headers: {
          order_field: 'nome',
          order: 'ASC',
          limit: 999
        }
      })

      this.guias = response.data.guias
    },
    sortGuiasBy (key) {
      if (this.currentSort === key) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.currentSort = key
        this.currentSortDir = 'asc'
      }
      this.guias.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[key] < b[key]) return -1 * modifier
        if (a[key] > b[key]) return 1 * modifier
        return 0
      })
    }
  },
  mounted () {
    this.buscaGuias()
  }
}
</script>

<style scoped>
#guia-impresso {
  padding: 20px 45px;
  margin-bottom: 70px;
}

*, ::before, ::after {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
}

.header {
  display: flex;
  place-content: space-between;
  place-items: center;
}

.table-header {
  padding-left: 15px;
  display: flex;
  justify-content: space-between;
}

.table-header span {
  cursor: pointer;
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.py-4 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
</style>
